<div class="main-layout">
  <app-progress-bar [ngClass]="{'hidden': !showProgressBar}" class="progress-bar" />
  <div class="top-buttons-frame">
    @if (backButton) {
      <app-button
        class="back"
        [text]="backButton.text"
        type="flat"
        leftIconSrc="/assets/icons/arrow-left.svg"
        [handleClick]="onClickBack"
        />
    }
    @if (exitButton && !eventData?.isEvent) {
      <app-button
        class="exit"
        [text]="exitButton.text"
        type="flat"
        rightIconSrc="/assets/icons/x.svg"
        [handleClick]="onClickExit"
        />
    }
    @if (eventData?.isEvent) {
      <app-button
        class="exit"
        text="Restart Form"
        type="flat"
        leftIconSrc="/assets/icons/restart.svg"
        [handleClick]="restartForm"
        />
    }
  </div>
  <ng-content></ng-content>
  @if (nextButton) {
    <div
      class="btn-next-wrapper"
      [ngClass]="{ centered: nextButton.position === 'center' }"
      >
      <app-button
        [text]="nextButton.text"
        [disabled]="!activateNextButton"
        type="filled"
        [rightIconSrc]="nextButton.noIcon ? '' : '/assets/icons/arrow-right-black.svg'"
        [handleClick]="onClickNext"
        />
    </div>
  }
  @if (isBookingPage) {
    <div class="text-link no-timeslots-work" [ngClass]="{'hide': !activateNoTimeslotsWorkButton}">
      <a (click)="onBookAppointmentWithoutTimeslotsClicked($event)" href="#">None of these times work for me</a>
    </div>
  }
</div>
